import React from 'react';
import { Brain, X } from 'lucide-react';

export const QuizHeader = ({ categoryName, phase, currentIdx, totalQuestions, onClose }) => (
  <div className="flex items-center gap-3 px-6 py-4 border-b border-white/10 flex-shrink-0">
    <div className="w-8 h-8 rounded-lg bg-teal-500/20 flex items-center justify-center">
      <Brain className="w-4 h-4 text-teal-400" />
    </div>
    <div className="flex-1">
      <h2 className="text-white font-semibold text-sm">AI Knowledge Base Coach</h2>
      <p className="text-white/40 text-xs">{categoryName}</p>
    </div>
    {phase === 'questions' && (
      <div className="flex items-center gap-2 mr-2">
        <div className="flex gap-1">
          {Array.from({ length: totalQuestions }).map((_, i) => (
            <div
              key={`dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i < currentIdx ? 'w-4 bg-teal-500'
                  : i === currentIdx ? 'w-6 bg-teal-400'
                  : 'w-4 bg-white/10'
              }`}
            />
          ))}
        </div>
        <span className="text-white/30 text-xs">{currentIdx + 1}/{totalQuestions}</span>
      </div>
    )}
    <button onClick={onClose} className="text-white/30 hover:text-white/60 transition-colors ml-1">
      <X className="w-5 h-5" />
    </button>
  </div>
);
